import {useListModalData} from '../../../hooks/useListModalData';
import {useListContext} from '../../../contexts/ListContext';
import GeneInfo from './ListModalGeneInfo';

import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {DataType} from "../../../types/enums";

const ListRowModal = () => {
  const {listState, setQueryModalResult, setLibraryModalResult} = useListContext();
  const [show, setShow] = useState(false);

  const modalData = useListModalData(
    listState.queryModalResult,
    listState.libraryModalResult,
    listState.selectedRowModal
  );

  useEffect(() => {
    if (listState.queryModalResult && listState.libraryModalResult) {
      setShow(true);
    }
  }, [listState.queryModalResult, listState.libraryModalResult]);

  const handleClose = () => {
    setQueryModalResult(null);
    setLibraryModalResult(null);
    setShow(false);
  };

  if (!modalData || !listState.selectedRowModal) return null;

  const isCorrelation = listState.dataType === DataType.Correlations;

  return (
    <Modal show={show} onHide={handleClose} centered size="xl">
      <Modal.Header closeButton className="border-0">
        <div className="d-flex flex-column align-items-center w-100">
          <Modal.Title>{modalData.modal.title}</Modal.Title>
          <h5>{modalData.modal.subtitle}</h5>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <GeneInfo
            type={isCorrelation ? "Library Gene (A)" : "Query Gene"}
            name={modalData.query.gene}
            entrezID={modalData.query.entrezID}
            symbol={modalData.query.symbol}
            description={modalData.query.description}
            uniprot={modalData.query.uniprot}
            expression={modalData.query.expression}
            expressionScore={modalData.query.expressionScore}
            essentiality={modalData.query.essentiality}
            fitnessLabel={modalData.query.fitnessLabel}
            fitnessScore={modalData.query.fitnessScore}
            fitnessVariability={modalData.query.fitnessVariability}
          />
          <GeneInfo
            type={isCorrelation ? "Library Gene (B)" : "Library Gene"}
            name={modalData.library.gene}
            entrezID={modalData.library.entrezID}
            symbol={modalData.library.symbol}
            description={modalData.library.description}
            uniprot={modalData.library.uniprot}
            expression={modalData.library.expression}
            expressionScore={modalData.library.expressionScore}
            essentiality={modalData.library.essentiality}
            fitnessLabel={modalData.library.fitnessLabel}
            fitnessScore={modalData.library.fitnessScore}
            fitnessVariability={modalData.library.fitnessVariability}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ListRowModal;
